"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PreviewCigaretteProps", {
  enumerable: true,
  get: function get() {
    return _PreviewCigarette.PreviewCigaretteProps;
  }
});
exports["default"] = void 0;
var _PreviewCigarette = require("./PreviewCigarette");
var _default = exports["default"] = _PreviewCigarette.PreviewCigarette;